import type { ReferencedTweetSummaryBasicInfoAllOf } from './referencedTweetSummaryBasicInfoAllOf';
import type { ReferencedTweetSummaryBasicInfoAllOfTwo } from './referencedTweetSummaryBasicInfoAllOfTwo';

export type ReferencedTweetSummaryBasicInfo = ReferencedTweetSummaryBasicInfoAllOf & ReferencedTweetSummaryBasicInfoAllOfTwo;
